const nameReg = /^\.\.\/containers\/App\/Unauthenticated\/(.+?)(?:\/index)?\.js$/;
const components = require('glob-loader?pattern=../containers/App/Unauthenticated/**/*.js!'); // eslint-disable-line

module.exports = Object.keys(components).reduce((result, file) => {
  const name = file.match(nameReg);
  return _.assign(
    _.zipObject([name ? name[1] : file], [components[file].default]),
  result);
}, {});
